import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomFetchApi from '../utils/customFetchApi';
import './MemoryWallStatsBanner.scss';

const MemoryWallStatsBanner = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const api = useCustomFetchApi(() => {});

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setIsLoading(true);
        // Fetch from configs endpoint
        const data = await api.get('/configs');
        
        if (data && data.configs) {
          // Extract statistics from configs response
          setStats({
            claimed: data.configs.user_count || 0,
            private: data.configs.private_count || 0,
            public: data.configs.public_count || 0,
            remaining: data.configs.remaining || 0
          });
        } else {
          // Fallback to default/mock data
          setStats({
            claimed: 0,
            private: 0,
            public: 0,
            remaining: 0
          });
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
        // Set default stats on error
        setStats({
          claimed: 0,
          private: 0,
          public: 0,
          remaining: 0
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (isLoading || !stats) {
    return null;
  }

  return (
    <div className="memory-wall-stats-banner">
      <div className="stats-container">
        <div className="stat-item claimed">
          <span className="stat-label">{t('memoryWall.stats.claimed')}</span>
          <span className="stat-value">{stats.claimed.toLocaleString()}</span>
        </div>
        <div className="stat-separator">|</div>
        <div className="stat-item private">
          <span className="stat-label">{t('memoryWall.stats.private')}</span>
          <span className="stat-value">{stats.private.toLocaleString()}</span>
        </div>
        <div className="stat-separator">|</div>
        <div className="stat-item public">
          <span className="stat-label">{t('memoryWall.stats.public')}</span>
          <span className="stat-value">{stats.public.toLocaleString()}</span>
        </div>
        <div className="stat-separator">|</div>
        <div className="stat-item remaining">
          <span className="stat-label">{t('memoryWall.stats.remaining')}</span>
          <span className="stat-value">{stats.remaining.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default MemoryWallStatsBanner;
